import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaExclamationTriangle, FaEye } from 'react-icons/fa';
import { BiLoaderAlt } from 'react-icons/bi';
import ReactTooltip from 'react-tooltip';
import { getLink } from '../../services/host';

import './style.css';

const ModuloTeste = ({
  status,
  modulo,
  isLoading,
  id_teste,
  n_modulo,
  need_validation,
  id_pesquisador = null,
  id_paciente = null,
}) => {
  useEffect(() => {
    if (need_validation) ReactTooltip.rebuild();
  }, [need_validation]);

  return (
    <div className="status-teste">
      {status === 1 ? (
        <div className="icon-status complete">
          <FaCheck />
        </div>
      ) : (
        <div className="icon-status">?</div>
      )}
      <div className="modulo">{modulo}</div>
      {isLoading !== false && (
        <div className="loading-module">
          <BiLoaderAlt />
        </div>
      )}
      {status === 1 && (
        <Link
          to={getLink(
            id_pesquisador
              ? `/pesquisador/${id_pesquisador}/paciente/${id_paciente}/teste/${id_teste}/modulo/${n_modulo}`
              : `/teste/${id_teste}/modulo/${n_modulo}`,
          )}
          className="btn-ver"
        >
          <FaEye />
        </Link>
      )}

      {need_validation && (
        <div
          className="btn-warning"
          data-tip="Existem respostas a serem validadas"
          data-for={`tooltip-module-${n_modulo}`}
        >
          <FaExclamationTriangle />
        </div>
      )}
      <ReactTooltip
        id={`tooltip-module-${n_modulo}`}
        place="top"
        effect="solid"
      />
    </div>
  );
};

export default ModuloTeste;
